import * as React from "react";
const SvgFiRrTruckPlow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-truck-plow_svg__a)">
      <path
        fill="#062147"
        d="M23.689 20.449a6.56 6.56 0 0 1-1.935-4.672V12.18a6.56 6.56 0 0 1 1.935-4.672.99.99 0 0 0 0-1.398c-1.978-1.6-4.206 4.566-3.913 6.07v.81h-2.103a3.97 3.97 0 0 0-2.02-2.528l-.01-.016-4.334-6.217a4.94 4.94 0 0 0-4.055-2.117h-.332A2.966 2.966 0 0 0 3.955 5.08v4.944A3.955 3.955 0 0 0 0 13.979v1.978c0 .706.377 1.358.989 1.711v.76a3.46 3.46 0 1 0 6.921 0v-.494h1.978v.495a3.46 3.46 0 1 0 6.922 0v-.76a1.98 1.98 0 0 0 .989-1.712v-.99h1.977v.81a8.53 8.53 0 0 0 2.515 6.07l.061.062c.946.902 2.253-.568 1.337-1.46M5.933 5.079c0-.545.443-.988.989-.988h.332A2.97 2.97 0 0 1 9.69 5.36l3.248 4.663H5.933zm-3.955 8.9c0-1.092.885-1.977 1.977-1.977h9.888c1.093 0 1.978.885 1.978 1.977v1.978H1.978zm3.955 4.45a1.483 1.483 0 1 1-2.967 0v-.495h2.967zm7.416 1.483c-.82 0-1.483-.664-1.483-1.483v-.495h2.966v.495c0 .819-.664 1.483-1.483 1.483"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-truck-plow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTruckPlow;
